import { cellAround, selectedRect } from '@tiptap/pm/tables';
import { EditorState } from '@tiptap/pm/state';
import styleVariables from '@/assets/scss/variables.module.scss';
import { ResourceType } from '@/types/resources';

export function isFirstRowSelected(state: EditorState) {
  const cellPos = cellAround(state.selection.$from);

  if (!cellPos) return false;

  const rect = selectedRect(state);

  return rect.top == 0;
}

const headerHeight = parseInt(styleVariables.columnHeaderHeight, 10);

export const FLOATING_MENU_HEIGHT = 40;
export const ARBITRARY_MENU_OFFSET = 20;

export function getVisiblePortionOfElement(target: Element) {
  const rect = target.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  const zeroHeight = headerHeight + FLOATING_MENU_HEIGHT + ARBITRARY_MENU_OFFSET;

  if (rect.bottom < zeroHeight) {
    return rect;
  }

  // Calculate the visible portion of the target element
  const top = Math.max(rect.top, zeroHeight);
  const left = Math.max(rect.left, 0);
  const right = Math.min(rect.right, windowWidth);
  const bottom = Math.min(rect.bottom, windowHeight);

  return {
    top,
    left,
    right,
    bottom,
    width: right - left,
    height: bottom - top,
  };
}

export type ContentExpressions = {
  [K in keyof typeof ResourceType as `${(typeof ResourceType)[K]}`]: string;
};
